export { default as H6 } from './H6'
